import React, { useState, useEffect } from "react";

import {
    Box,
    Button,
    TextField,
    Grid,
    styled,
    Card,
} from '@mui/material';

// import { useNavigate } from "react-router-dom"
import { useFormik } from 'formik';

// import CommonBreadcumbs from '../../../common/CommonBreadcumbs';
import CommonSectionHeader from "../../../common/CommonSectionHeader"
// import CommonRestricted from '../../../common/CommonRestricted';
import { useAppContextFeatures } from '../../../../context/AppContext';

// import { useSystemRoutes, routeTypes } from '../../../../hooks/useSystemRoutes';

import { useSettings, defaultTypes, defaultSettings, getCreatePayload, getListFilters } from "../../../../hooks/api/useSettings";
import { useTranslations } from '../../../../hooks/useTranslations';
import { useSystemPrompt } from "../../../../hooks/useSystemPrompt";

// import { useSystemHead, headTitles } from '../../../../hooks/useSystemHead';

import { initialValues, validationSchema } from '../../../../schema/setting/email/smtpSchema'

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const RenderForm = ({
    values,
    handleChange,
    errors,
    touched,
}) => {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={3} sx={{ mt: 1 }}>
                <CommonSectionHeader
                    title={"From Email"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    autoFocus
                    fullWidth
                    name={"fromEmail"}
                    type="text"
                    variant="outlined"
                    value={values?.fromEmail}
                    onChange={handleChange}
                    error={touched.fromEmail && Boolean(errors.fromEmail)}
                    helperText={touched.fromEmail && errors.fromEmail}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={3} sx={{ mt: 1 }}>
                <CommonSectionHeader
                    title={"From Name"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"fromName"}
                    type="text"
                    variant="outlined"
                    value={values?.fromName}
                    onChange={handleChange}
                    error={touched.fromName && Boolean(errors.fromName)}
                    helperText={touched.fromName && errors.fromName}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={3} sx={{ mt: 1 }}>
                <CommonSectionHeader
                    title={"Reply-To Name"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"replyName"}
                    type="text"
                    variant="outlined"
                    value={values?.replyName}
                    onChange={handleChange}
                    error={touched.replyName && Boolean(errors.replyName)}
                    helperText={touched.replyName && errors.replyName}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={3} sx={{ mt: 1 }}>
                <CommonSectionHeader
                    title={"Reply-To Email"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"replyEmail"}
                    type="text"
                    variant="outlined"
                    value={values?.replyEmail}
                    onChange={handleChange}
                    error={touched.replyEmail && Boolean(errors.replyEmail)}
                    helperText={touched.replyEmail && errors.replyEmail}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={3}>
                <CommonSectionHeader
                    title={"Host"}
                    subTitle={"ie. smtp.gmail.com"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"hostUrl"}
                    type="text"
                    variant="outlined"
                    value={values?.hostUrl}
                    onChange={handleChange}
                    error={touched.hostUrl && Boolean(errors.hostUrl)}
                    helperText={touched.hostUrl && errors.hostUrl}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={3}>
                <CommonSectionHeader
                    title={"Port"}
                    subTitle={"ie. 25,587,465"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"hostPort"}
                    type="text"
                    variant="outlined"
                    value={values?.hostPort}
                    onChange={handleChange}
                    error={touched.hostPort && Boolean(errors.hostPort)}
                    helperText={touched.hostPort && errors.hostPort}
                />
            </Grid>

        </Grid>
    )
}

export default function SmtpSetting({
    routeType
}) {

    const { t } = useTranslations({ ns: ["common", "@user", "sidebar"] })

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading } = useAppContextFeatures()

    const { create, list } = useSettings(defaultTypes.email_gateway.id);

    // const navigate = useNavigate();
    // const { getRoute } = useSystemRoutes(routeType);
    // const { getHtmlHead } = useSystemHead(routeType)
    const [savedValues, setSavedValues] = useState(initialValues)

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            let propsData = [
                {
                    key: defaultSettings.email_gateway.smtp.props.fromEmail,
                    value: currentValues.fromEmail,
                    label: "xx"
                },
                {
                    key: defaultSettings.email_gateway.smtp.props.fromName,
                    value: currentValues.fromName,
                    label: "xx"
                },
                {
                    key: defaultSettings.email_gateway.smtp.props.replyName,
                    value: currentValues.replyName,
                    label: "xx"
                },
                {
                    key: defaultSettings.email_gateway.smtp.props.replyEmail,
                    value: currentValues.replyEmail,
                    label: "xx"
                },
                {
                    key: defaultSettings.email_gateway.smtp.props.hostUrl,
                    value: currentValues.hostUrl,
                    label: "xx"
                },
                {
                    key: defaultSettings.email_gateway.smtp.props.hostPort,
                    value: currentValues.hostPort,
                    label: "xx"
                },

            ]

            let loadInfo = getCreatePayload({
                typeId: defaultTypes.email_gateway.id,
                typeName: "",
                settingId: defaultSettings.email_gateway.smtp.id,
                settingName: '',
                props: propsData
            })

            let data = {
                settings: [loadInfo]
            }

            const response = await create({ data });

            console.log("Data", response)

            promptMessage(true, `${response?.message}`)

            // navigate(getRoute("settings"))

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const fetchSetting = async () => {

        setSystemLoading(true)

        try {

            let filterValues = getListFilters({
                typeKey: defaultTypes.email_gateway.key,
                settingKey: defaultSettings.email_gateway.smtp.key,
                // settingKeys: [],
                fieldKeys: [
                    defaultSettings.email_gateway.smtp.props.fromEmail,
                    defaultSettings.email_gateway.smtp.props.fromName,
                    defaultSettings.email_gateway.smtp.props.hostPort,
                    defaultSettings.email_gateway.smtp.props.hostUrl,
                    defaultSettings.email_gateway.smtp.props.replyEmail,
                    defaultSettings.email_gateway.smtp.props.replyName,
                ]
            })

            const props = {
                limit: -1,
                skip: 0,
                filterValue: filterValues,
                sortInfo: {
                    id: "id",
                    dir: -1
                },
            }

            const response = await list(props);

            // console.log("Data", response)

            if (response?.data?.settings) {
                let savedSettings = response.data.settings

                let _fromEmail = ""
                let _fromName = ""
                let _replyEmail = ""
                let _replyName = ""
                let _hostUrl = ""
                let _hostPort = ""

                savedSettings.forEach(i => {
                    if (i.field_key === defaultSettings.email_gateway.smtp.props.fromEmail) {
                        _fromEmail = i.field_value
                    }
                    if (i.field_key === defaultSettings.email_gateway.smtp.props.fromName) {
                        _fromName = i.field_value
                    }
                    if (i.field_key === defaultSettings.email_gateway.smtp.props.replyEmail) {
                        _replyEmail = i.field_value
                    }
                    if (i.field_key === defaultSettings.email_gateway.smtp.props.replyName) {
                        _replyName = i.field_value
                    }
                    if (i.field_key === defaultSettings.email_gateway.smtp.props.hostUrl) {
                        _hostUrl = i.field_value
                    }
                    if (i.field_key === defaultSettings.email_gateway.smtp.props.hostPort) {
                        _hostPort = i.field_value
                    }
                })

                setSavedValues({
                    ...initialValues,
                    fromEmail: _fromEmail,
                    fromName: _fromName,
                    replyEmail: _replyEmail,
                    replyName: _replyName,
                    hostUrl: _hostUrl,
                    hostPort: _hostPort
                })
            }

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    useEffect(() => {

        fetchSetting()

    }, [])

    return (
        <form onSubmit={formik.handleSubmit}>
            <StyledCard>

                <RenderForm
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    touched={touched}
                />

            </StyledCard>
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                <Grid item md={12} textAlign={"right"}>
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2
                        }}
                    >
                        {t('saveChanges')}
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}